export const COLLECTOR_TIERS = Object.freeze({
  TIER1: "tier1",
  TIER2: "tier2",
  TIER3: "tier3"
});

const ADMIN_ROLE = "admin";

const COLLECTOR_TIER_DEFINITIONS = Object.freeze({
  [COLLECTOR_TIERS.TIER1]: Object.freeze({
    id: COLLECTOR_TIERS.TIER1,
    label: "Collector Tier 1",
    shortLabel: "Tier 1",
    iconTone: "bronze",
    myTradersLimit: 10000,
    myWantsLimit: 10000
  }),
  [COLLECTOR_TIERS.TIER2]: Object.freeze({
    id: COLLECTOR_TIERS.TIER2,
    label: "Collector Tier 2",
    shortLabel: "Tier 2",
    iconTone: "silver",
    myTradersLimit: 50000,
    myWantsLimit: 20000
  }),
  [COLLECTOR_TIERS.TIER3]: Object.freeze({
    id: COLLECTOR_TIERS.TIER3,
    label: "Collector Tier 3",
    shortLabel: "Tier 3",
    iconTone: "gold",
    myTradersLimit: 500000,
    myWantsLimit: 30000
  })
});

export function normalizeCollectorTier(value, fallback = COLLECTOR_TIERS.TIER1) {
  const normalizedValue = String(value ?? "").trim().toLowerCase();

  if (Object.values(COLLECTOR_TIERS).includes(normalizedValue)) {
    return normalizedValue;
  }

  return fallback;
}

export function getCollectorTierDefinition(value) {
  return COLLECTOR_TIER_DEFINITIONS[normalizeCollectorTier(value)] || COLLECTOR_TIER_DEFINITIONS[COLLECTOR_TIERS.TIER1];
}

export function getCollectorTierDefinitionForRole(value, role) {
  if (String(role ?? "collector").trim().toLowerCase() === ADMIN_ROLE) {
    return getCollectorTierDefinition(COLLECTOR_TIERS.TIER3);
  }

  return getCollectorTierDefinition(value);
}

export function shouldShowCollectorTierBadge(role) {
  return ["collector", ADMIN_ROLE].includes(String(role ?? "collector").trim().toLowerCase());
}

export function formatCollectorTierLimit(limit) {
  if (limit === null || limit === undefined) {
    return "Unlimited";
  }

  return new Intl.NumberFormat().format(Number(limit) || 0);
}

export function buildCollectorTierOptions() {
  return Object.values(COLLECTOR_TIERS).map((tier) => {
    const definition = getCollectorTierDefinition(tier);

    return {
      value: definition.id,
      label: definition.label,
      description: `${formatCollectorTierLimit(definition.myTradersLimit)} My Traders · ${formatCollectorTierLimit(definition.myWantsLimit)} My Wants`
    };
  });
}